import gql from 'graphql-tag'

export const UPLOAD_ARQUIVOS = gql`
  mutation UploadArquivosMutation($arquivos: [ItemBibliotecaInput!]!) {
    uploadArquivos(arquivos: $arquivos) {
      id
      nome
      pastaPai {
        id
      }
    }
  }
`
